import { createFileRoute } from '@tanstack/react-router'
import { BookingSearchPage } from '@/features/bookings/search'

export const Route = createFileRoute('/bookings_/search')({
  component: BookingSearchPage,
})
